import { BehaviorSubject } from 'rxjs';
import { Data } from '@angular/router';
import { Injectable } from '@angular/core';
import { loginWithGithub } from 'github-oauth-popup';
import { AuthService as NativeAuthService, } from 'angularx-social-login';

@Injectable()
export class SocialLoginService extends NativeAuthService {
    private user$: BehaviorSubject<Data> = new BehaviorSubject<Data>({});

    public get user() {
        return this.user$.asObservable();
    }

    public set user(model: Data) {
        this.user$.next(model);
    }

    public checkAuthState() {
        this.authState.subscribe((user: Data) =>
            this.user = user);
    }

    public signInGitHub(clientId) {
        loginWithGithub({ client_id: clientId }).then(({ code: idToken }) =>
            this.user = { idToken, provider: 'GITHUB' });
    }
}
